var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineMarks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.69 30.31h20.62M14.5 24.81h-2.75a.69.69 0 00-.69.69v4.81h4.13V25.5a.69.69 0 00-.69-.69zM21.38 20.69h-2.76a.69.69 0 00-.68.69v8.93h4.12v-8.93a.69.69 0 00-.68-.69zM28.25 17.94H25.5a.69.69 0 00-.69.68v11.69h4.13V18.62a.69.69 0 00-.69-.68zM12.83 17.47l14.73-6.69M26.47 13.7l1.09-2.92-2.91-1.09"
  }))));
}
export default SvgStreamlineMarks;